module.exports = __webpack_public_path__ + "static/img/oilSlogin.953fa9f3.png";